export function setInsuranceDocument(state, data) {
    state.insurance_document = data
    this.dispatch('insurance/getAgents');
}

export function setInsuranceAgent(state, data) {
    state.insurance_agent = data
}

export function setInsuranceAgents(state, data) {
    state.agents = data
}




